<div class="flex w-full min-h-screen max-h-screen flex-col md:flex-row">
    <div class="w-full md:w-1/2 bg-white flex min-h-screen md:min-h-0">
        <div class="w-full px-4 sm:px-6 py-8 md:px-12 lg:px-40 flex flex-col justify-center gap-4 md:gap-5">
            <div class="flex flex-col gap-2 md:gap-3">
                <div class="text-2xl sm:text-3xl md:text-4xl font-extrabold font-bricolage">
                    {{'Welcome!' | textCase}},
                    <br>
                    {{'Sign-up to your account!' | textCase}}
                </div>
                <span class="text-base sm:text-lg md:text-xl">{{'Already have one?' | textCase}}
                    <a href="/login" class="theme-text font-medium">{{'Login' | textCase}}</a>
                </span>
            </div>
            <div class="w-full">
                <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" class="w-full">
                    <div class="flex flex-col gap-2">
                        <div class="flex flex-col gap-2">
                            <label class="text-sm md:text-base font-medium" for="email">{{'Email' | textCase}}</label>
                            <input id="email" class="input w-full" type="email" pInputText formControlName="email"
                                placeholder="{{'name@yourcompany.com' | textCase:CASE_TYPE.LOWER}}">
                            @if(signupForm.controls['email'].errors && signupForm.controls['email'].touched){
                            <div class="text-danger ml-1"><small>*{{"A valid email is Required" | textCase}}</small>
                            </div>
                            }
                        </div>
                        @if(organizationExists) {
                        <div
                            class="mt-4 w-full border border-orange-200 bg-orange-50 rounded-lg p-3 flex flex-col gap-2">
                            <div class="text-sm text-orange-800 font-semibold">
                                {{"An organization already exists for" | textCase}}
                                {{organizationWithSameDomain?.domain}}.
                            </div>
                            <div class="text-sm text-gray-700">
                                {{"Would you like to request to join" | textCase}} {{organizationWithSameDomain?.name}}?
                            </div>
                            <div class="flex flex-col sm:flex-row gap-2 w-full">
                                <app-button variant="filled" severity="primary"
                                    [label]="joinRequestLoading ? 'Requesting...' : ('Request to join' | textCase)"
                                    [disabled]="joinRequestLoading || joinRequestSuccess"
                                    (clicked)="requestToJoinExistingOrg()" class="flex-1" />
                                <app-button variant="outlined" severity="contrast" [disabled]="joinRequestLoading"
                                    (clicked)="cancelJoinRequest()" label="{{'Cancel' | textCase}}" class="flex-1" />
                            </div>
                            @if(joinRequestSuccess) {
                            <div class="text-sm text-green-700">
                                {{"Request sent. We will notify you once approved." | textCase}}
                            </div>
                            }
                        </div>
                        } @else {
                        <div class="w-full">
                            <app-button variant="filled" severity="primary" label="{{'Continue' | textCase}}"
                                [disabled]="!signupForm.valid" (clicked)="onSubmit()" [fullWidth]="true" />
                        </div>
                        }
                    </div>
                </form>
            </div>
            <div class="w-full text-slate-600 text-xs sm:text-sm">
                <p>{{'By creating an account, you agree to our' | textCase}}
                    <a class="underline" href="https://inncircles.ai/terms/" target="_blank">{{'Terms of service' |
                        textCase}}</a>
                    and <a class="underline" href="https://inncircles.com/privacy-policy/" target="_blank">{{'Privacy
                        Policy' | textCase}}</a>
                </p>
            </div>
        </div>
    </div>
    <div class="hidden md:flex md:w-1/2 overflow-hidden">
        <img class="h-full w-full object-cover" [src]="'images/login-page.svg' | assetUrl" alt="login-image">
    </div>
</div>